export default {
  mask: {
    preview: {
      luminance: "輝度マスクプレビュー",
      rgb: "RGB マスクプレビュー",
      dialogTitle: "マスクプレビュー",
    },
    tabs: {
      luminance: "輝度",
      rgb: "RGB",
    },
    channels: {
      rgb: "RGB",
      r: "R",
      g: "G",
      b: "B",
    },
    controls: {
      channel: "チャンネル",
      zone: "ゾーン",
      fineTune: "微調整を切り替え",
      fineTuneShow: "微調整",
      fineTuneHide: "微調整を隠す",
      hideMapping: "マッピングを非表示",
      showMapping: "マッピングを表示",
      showOriginal: "オリジナルを表示",
      showGray: "グレースケールを表示",
      showLegend: "凡例を表示",
      renderMode: "描画モード切替",
      renderModeWebgl: "WebGL（GPU）",
      renderModeCanvas: "Canvas 2D（CPU）",
      renderModeSwitch: "クリックして切替",
      showLabStats: "LAB 統計",
      showHslStats: "HSL 統計",
    },
    loadingPreview: "プレビューを読み込み中",
    retry: "再試行",
    retryButton: "再試行",
    zone: {
      blacks: "ブラック",
      shadows: "シャドウ",
      midtones: "ミッドトーン",
      highlights: "ハイライト",
      whites: "ホワイト",
    },
    clipping: {
      title: "クリッピング",
      band: {
        hard: "Hard",
        near: "Near",
      },
      side: {
        left: "シャドウ側",
        right: "ハイライト側",
      },
    },
    legend: {
      red: "レッドチャンネル",
      green: "グリーンチャンネル",
      blue: "ブルーチャンネル",
      twoChannels: "2チャンネル",
      allChannels: "全チャンネル",
      solidColor: "単色",
      redGreen: "赤 + 緑",
      redBlue: "赤 + 青",
      greenBlue: "緑 + 青",
    },
    slider: {
      slice: "スライス",
      range: "範囲",
      sliderMode: "スライダーモード",
    },
  },
  hover: {
    rgb: "RGB",
    luminance: "輝度",
    placeholder: {
      title: "ポイントインスペクターのプレースホルダー",
      description:
        "解放すると、現在のカーソル位置にある RGB / LAB / HSL の正確な値を確認できます。",
      locked: "未解放",
      secondaryTitle: "追加の色空間",
    },
    channel: {
      r: "R:",
      g: "G:",
      b: "B:",
      l: "L:",
    },
    hslHueWithName: "{value}（{name}）",
  },
  region: {
    previewTitle: "領域マスクプレビュー",
    controls: {
      region: "領域",
    },
    options: {
      foreground: "前景",
      background: "背景",
    },
  },
  zone: {
    global: "全体解析",
    zoneAnalysisTitle: "{zone} 解析",
    loading: "解析を読み込み中",
  },
  lab: {
    dialogTitle: "LAB 統計 - {zone}",
    toggleEn: "EN",
    toggleZh: "中",
    download: "統計をダウンロード",
    loadingAnalysis: "解析を読み込み中",
    loadingStatistics: "統計を読み込み中",
    empty: "このゾーンの統計データはありません",
    zone: {
      analysis: "分析",
      global: "全体",
      blacks: "ブラック",
      shadows: "シャドウ",
      midtones: "ミッドトーン",
      highlights: "ハイライト",
      whites: "ホワイト",
    },
    metric: {
      title: "指標",
      channel: "{channel} チャンネル",
      mean: "平均",
      median: "中央値",
      mode: "最頻値",
      min: "最小",
      max: "最大",
      q1: "Q1（25%）",
      q3: "Q3（75%）",
      std: "標準偏差",
      variance: "分散",
      skewness: "歪度",
      kurtosis: "尖度",
    },
    section: {
      overall: "全体の結論",
      global: "全体解析",
      partition: "ゾーン解析",
    },
  },
  boxplot: {
    legend: {
      whisker: "上ホイッスカー / 下ホイッスカー",
      box: "ボックス上端 / ボックス下端",
      median: "中央値線",
      mean: "平均クロス",
    },
  },
  hsl: {
    dialogTitle: "HSL 統計 - {zone}",
    download: "統計をダウンロード",
    loadingStatistics: "統計を読み込み中",
    empty: "このゾーンの統計データはありません",
    zone: {
      global: "全体",
      blacks: "ブラック",
      shadows: "シャドウ",
      midtones: "ミッドトーン",
      highlights: "ハイライト",
      whites: "ホワイト",
    },
    metric: {
      title: "指標",
      channel: "{channel} チャンネル",
      mean: "平均",
      median: "中央値",
      mode: "最頻値",
      min: "最小",
      max: "最大",
      q1: "Q1（25%）",
      q3: "Q3（75%）",
      std: "標準偏差",
      variance: "分散",
      skewness: "歪度",
      kurtosis: "尖度",
    },
  },
  ai: {
    loading: "画像を分析中...",
    errorPrefix: "分析に失敗しました:",
    errorPrefixZh: "分析失敗:",
  },
  histogram: {
    title: {
      rgb: "RGB 分布",
      tonal: "トーン分布",
    },
    exportFile: "histogram_distribution.json",
    headers: {
      zone: "ゾーン",
      sum: "合計",
      prop: "割合",
      avg: "平均",
    },
    average: "平均",
    pixels: "ピクセル",
    tab: {
      rgb: "RGB",
      red: "レッド",
      green: "グリーン",
      blue: "ブルー",
      gray: "グレー",
      luminosity: "輝度",
    },
    span: {
      short: "短",
      mid: "中",
      long: "長",
    },
  },
  chart: {
    defaultTitle: "トーンヒストグラム",
    loading: "チャートを読み込み中",
    title: {
      rgbHistogram: "RGB ヒストグラム",
      rgbOverlay: "RGB チャンネル重ね合わせ",
      redChannel: "レッドチャンネル",
      greenChannel: "グリーンチャンネル",
      blueChannel: "ブルーチャンネル",
      gray: "グレー",
      luminosity: "輝度",
      brightness: "明るさ（HSV）",
      lightness: "明度（LAB）",
    },
    description: {
      gray: "赤・緑・青をバランスよく配分した標準的なモノクロ表現です。クラシックな階調分布を再現し、色に惑わされずに白黒写真の構図、明暗の対比、画面構成を分析するのに適しています。",
      luminosity:
        "人間の視覚に合わせて緑を重く、青を軽く重み付けした、露出評価の基準となる指標です。視覚的な白飛びや黒潰れを正確に判断し、肉眼での見え方に近い自然な露出調整を行う際に不可欠です。",
      brightness:
        "カラーチャンネルの最大値を基準とする純粋な数学的表現で、鮮やかな色に対して極めて敏感に反応します。露出の判断よりも、特定のカラー範囲の抽出や、HSL調整における高彩度色の分離に適しています。",
      lightness:
        "知覚の均一性を重視し、明るさを色情報から完全に分離した尺度です。ハイエンドなトーンカーブ調整に最適で、色相のズレや不自然な彩度上昇を引き起こすことなく、コントラストやディテールを緻密にコントロールできます。",
    },
    legend: {
      red: "R チャンネル",
      green: "G チャンネル",
      blue: "B チャンネル",
    },
    axis: {
      intensity: "強度レベル",
      frequency: "頻度",
    },
    controls: {
      reset: "リセット",
      toggleChannels: "チャンネル切替",
    },
  },
  palette: {
    tabs: {
      global: "全体",
    },
    labels: {
      hex: "HEX",
      rgb: "RGB",
    },
    distribution: {
      hue: "色相分布",
      saturation: "彩度分布",
      lightness: "明度分布",
    },
    harmony: {
      title: "カラーハーモニー",
      wheel: "ハーモニーホイール",
      legendDots: "ドットは主要色、サイズは優先度を示します。",
      legendLines: "破線は色相関係を示します。",
      typeLabel: "タイプ:",
      relationshipsLabel: "関係:",
      distributionLabel: "分布:",
      types: {
        complementary: "補色",
        triadic: "トライアド",
        analogous: "類似",
        splitComplementary: "スプリット補色",
        tetradic: "テトラード",
        square: "スクエア",
        monochrome: "モノクローム",
        neutral: "ニュートラル",
        custom: "カスタム",
      },
      summaries: {
        complementary: "強いコントラストでエネルギッシュ。",
        triadic: "均等な3色でバランスが良い。",
        analogous: "隣接色で滑らかな印象。",
        splitComplementary: "柔らかい対比で安定感。",
        tetradic: "2つの補色ペアで豊かな変化。",
        square: "4色均等で大胆な印象。",
        monochrome: "単一色で微妙な変化。",
        neutral: "低彩度で落ち着いた印象。",
        custom: "明確なハーモニー構造がありません。",
      },
      descriptions: {
        customStrong: "調和は強いものの、典型的な構造はありません。",
        customBalanced: "全体的にバランスは良いが明確な構造はありません。",
        customWeak: "色相の構造が散らばっています。",
        strong: "色の調和が非常に良好です。",
        good: "調和は良好で、微調整が可能です。",
        weak: "調和が弱く、改善が必要です。",
      },
    },
    hueRanges: {
      red: "赤",
      orange: "オレンジ",
      yellow: "黄",
      yellowGreen: "黄緑",
      green: "緑",
      greenCyan: "緑青",
      cyan: "シアン",
      cyanBlue: "シアンブルー",
      blue: "青",
      blueMagenta: "青紫",
      magenta: "マゼンタ",
      magentaRed: "赤紫",
    },
    saturationRanges: {
      low: "低",
      mediumLow: "やや低",
      medium: "中",
      mediumHigh: "やや高",
      high: "高",
    },
    lightnessRanges: {
      veryDark: "とても暗い",
      dark: "暗い",
      medium: "中間",
      light: "明るい",
      veryLight: "とても明るい",
    },
    statistics: {
      title: "全体統計",
      colorCount: "色数",
      mainColorProportion: "主色比率",
      colorfulness: "鮮やかさ",
      averageSaturation: "平均彩度",
      averageLightness: "平均明度",
      contrastRatio: "コントラスト比",
    },
    empty: "カラーデータがありません",
    copied: "コピー済み",
  },
};
